import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import LOOutcomeModalCst from "@components/LOOutcomeModalCst";
import PathWizard from "../Path/PathWizard";
import { useSubmitPathV2 } from "../Path/hooks/useSubmitPathV2";
import { EMPTY_PATH_DATA, PathWizardData } from "../Path/types";

const AddPath: React.FC = () => {
  const navigate = useNavigate();
  const { id: corporateId = "" } = useParams();
  const catalogUrl = `/v2/corporate/${corporateId}/detail/catalog`;

  const { submit: submitPath, isSubmitting } = useSubmitPathV2({
    corporateId,
  });

  const [successOpen, setSuccessOpen] = useState(false);

  const handleComplete = async (data: PathWizardData) => {
    try {
      await submitPath(data);
      setSuccessOpen(true);
    } catch (error) {
      console.error("[path-wizard] publish failed", error);
      throw error;
    }
  };

  return (
    <>
      <PathWizard
        initialData={EMPTY_PATH_DATA}
        onComplete={handleComplete}
        isSubmitting={isSubmitting}
      />
      <LOOutcomeModalCst
        open={successOpen}
        entityType="path"
        mode="add"
        onDismiss={() => navigate(catalogUrl)}
      />
    </>
  );
};

export default AddPath;
